import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { ActivityDataProvider } from "../../data-provider/activity.dp";
import { HouseOccupant } from "../../models/house-occupant.model";
import { House } from "../../models/house.model";
import { PermissionCheck } from "../../shared/permission";
import { CanvassService } from "../../services/canvass.service";
import { HouseOccupantService } from "../../services/house-occupant.service";
import { HouseService } from "../../services/house.service";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { HouseDataProvider } from "../../data-provider/house.dp";
import { HouseHelperService } from "./house.helper";
import { EffortDataProvider } from "../../data-provider/effort.dp";
import { Effort } from "../../models/effort.model";

let HousePaneComponent = {
    selector: "vcHousePane",
    templateUrl: "/angular/components/house/house-pane.component.html",
    bindings: {
        updated: "&",
        deleted: "&",
        canvassed: "&",
        closePane: "&",
        houseLoading: "&",
        selectedHouse: "=",
        hid: "=",
        showEffortHelper: "=?",
    },
    controller: class HousePaneController {
        // * bindings for typescript compiler *
        public updated: any;
        public deleted: any;
        public canvassed: any;
        public closePane: any;
        public houseLoading: any;
        public selectedHouse: any;
        public hid: any;
        public showEffortHelper?: boolean;
        // ************************************

        public houseMarker?: any;
        public essentialsMode: boolean;
        public house: House;
        public isLeaderView: boolean;
        public personLink = true;
        public activityItems: Array<any> | undefined = undefined;
        public effortCount: number = 0;
        public selectedEffortName: string = "";
        public showMap = false;
        public map = {
            bounds: {},
            center: { latitude: 0, longitude: 0 },
            zoom: 3,
            control: {},
            options: { scrollwheel: false },
        };
        public locating: boolean | undefined = undefined;
        private closing = false;

        private $scope: any;
        private service: HouseService;
        private activityDataProvider: ActivityDataProvider;
        private houseOccupantService: HouseOccupantService;
        private dataProvider: HouseDataProvider;
        private campaignDataProvider: CampaignDataProvider;
        private helperService: HouseHelperService;
        private dialog: DialogUtils;
        private __app_type: string;
        private toast: ToastUtils;
        private $timeout: any;
        private canvassService: CanvassService;
        private modelsUtils: any;
        private effortDataProvider: EffortDataProvider;
        public permissionProvider: PermissionCheck;
        public __env: any;

        constructor(
            $scope: any,
            HouseService: HouseService,
            ActivityDataProvider: ActivityDataProvider,
            HouseOccupantService: HouseOccupantService,
            HouseDataProvider: HouseDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            HouseHelperService: HouseHelperService,
            DialogUtils: DialogUtils,
            __app_type: string,
            ToastUtils: ToastUtils,
            $timeout: object,
            CanvassService: CanvassService,
            PermissionCheck: PermissionCheck,
            ModelsUtils: any,
            __env: any,
            EffortDataProvider: EffortDataProvider
        ) {
            this.$scope = $scope;
            this.service = HouseService;
            this.activityDataProvider = ActivityDataProvider;
            this.houseOccupantService = HouseOccupantService;
            this.dataProvider = HouseDataProvider;
            this.campaignDataProvider = CampaignDataProvider;
            this.helperService = HouseHelperService;
            this.dialog = DialogUtils;
            this.__app_type = __app_type;
            this.toast = ToastUtils;
            this.$timeout = $timeout;
            this.canvassService = CanvassService;
            this.permissionProvider = PermissionCheck;
            this.__env = __env;
            this.modelsUtils = ModelsUtils;
            this.effortDataProvider = EffortDataProvider;
            this.isLeaderView = this.__app_type == "LEADER";

            this.essentialsMode =
                this.campaignDataProvider.activeCampaign.campaignstatusid ==
                "5";

            // $mdDialog.hide() resolves whichever dialog is topmost, so never
            // hand the house to it here: on a route change the open dialog
            // could be somebody else's (AV-18111). Cancel instead.
            this.$scope.$on("$routeChangeStart", () => this.dialog.cancel());

            this.$timeout(() => (this.showMap = true), 500);
        }

        loadHouseDetails(): void {
            this.service.info({ id: this.hid }).then((response: object) => {
                const json = response["data"];
                this.houseLoading = false;
                if (json.success) {
                    this.house = this.modelsUtils.house(json.data);
                    for (let i = 0; i < this.house.occupants.length; i++) {
                        this.house.occupants[i] =
                            this.modelsUtils.houseOccupant(
                                this.house.occupants[i]
                            );
                    }
                    this.initialiseMap();
                }
            });

            this.activityItems = [];
            this.activityDataProvider
                .getHouseActivity(this.hid)
                .then((activity: any) => {
                    this.activityItems = activity;
                });
        }

        loadEffortContext(): void {
            this.effortDataProvider.getAllEfforts().then(
                (efforts: Effort[]) => {
                    this.effortCount = efforts.length;
                },
                () => {
                    this.effortCount = 0;
                }
            );
            this.effortDataProvider
                .getSelectedEffort()
                .then((effort: Effort) => {
                    this.selectedEffortName = effort.name || "";
                });
        }

        $onInit(): void {
            if (this.selectedHouse) {
                this.hid = this.isLeaderView
                    ? this.selectedHouse.id
                    : this.selectedHouse.hid;
            }
            this.loadHouseDetails();
            this.loadEffortContext();

            this.$scope.$watch(
                () => this.hid,
                (
                    newValue: string | number | undefined,
                    oldValue: string | number | undefined
                ) => {
                    this.houseLoading = true;
                    if (oldValue && newValue != oldValue) {
                        this.loadHouseDetails();
                    }
                }
            );
        }

        close(house: House): void {
            if (this.closing) return;
            this.closing = true;
            if (this.closePane) this.closePane();
            this.dialog.hide(house);
        }

        openSummaryDialog(canvass: any, ev: object): void {
            this.dialog.show({
                component: "vc-view-summary-dialog",
                targetEvent: ev,
                scope: this.$scope,
                locals: {
                    signature: canvass.signature,
                    summary: canvass.summary,
                },
            });
        }

        openEditHouseDialog(house: House, ev: object): void {
            this.dialog
                .show({
                    component: "vc-house-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    ariaLabel: "House",
                    locals: {
                        selectedHouse: house,
                    },
                    size: "x-large",
                })
                .then((data: object) => {
                    house.setData(data);
                    this.initialiseMap();
                    if (this.updated) {
                        this.updated({ house: house });
                    }
                });
        }

        openHouseNoteDialog(house: House, ev: object): void {
            this.dialog
                .show({
                    component: "vc-house-note-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        houseNote: house.notes,
                    },
                })
                .then((data: unknown) => {
                    if (typeof data !== "string") return;
                    this.house.notes = data;
                    this.house.update();
                });
        }

        deleteHouseDialog(house: House, ev: object): void {
            this.dialog
                .delete({
                    fullscreen: true,
                    targetEvent: ev,
                    multiple: true,
                    locals: {
                        bodyText:
                            "This action will permanently delete this house from your database. Any analytics associated with these contacts will also be deleted.",
                        title: "Delete House?",
                    },
                })
                .then(() => {
                    this.dataProvider
                        .delete(house)
                        .then((returnedHouse: object) => {
                            this.toast.success("House deleted.");
                            this.dialog.hide(returnedHouse);
                            if (this.deleted) this.deleted();
                        });
                });
        }

        deleteCanvass(canvass: any, ev: object): void {
            this.dialog
                .delete({
                    fullscreen: true,
                    targetEvent: ev,
                    multiple: true,
                    locals: {
                        bodyText:
                            "This will permanently delete the interaction",
                        title: "Delete Interaction?",
                    },
                })
                .then(() => {
                    this.canvassService
                        .delete({ id: canvass.csid })
                        .then((response: object) => {
                            const json = response["data"];
                            if (json.success) {
                                this.activityDataProvider.removeActivity(
                                    canvass
                                );
                                this.activityItems.splice(
                                    this.activityItems.indexOf(canvass),
                                    1
                                );
                                this.toast.success("Interaction deleted");
                            } else {
                                this.toast.error();
                            }
                        });
                });
        }

        openCanvassDialog(
            canvass: any,
            houseoccupant: HouseOccupant,
            house: House,
            ev: object
        ): void {
            this.dialog
                .show({
                    component: "vc-canvass-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        selectedHouseOccupant: houseoccupant,
                        selectedHouse: house,
                        selectedCanvass: canvass,
                    },
                    size: "large",
                    ariaLabel: "Interaction",
                })
                .then((data: any) => {
                    if (data.house) {
                        this.house.notes = data.house.notes;
                    }
                    if (data.houseoccupant.house) {
                        this.house.notes = data.houseoccupant.house.notes;
                    }
                    if (this.canvassed) this.canvassed();

                    if (!canvass || !canvass.csid) {
                        data.atype = "canvass";
                        this.activityItems.unshift(data);
                    } else {
                        if (!data.issue) {
                            canvass.issue = null;
                        }
                        if (!data.survey) {
                            canvass.survey = null;
                        }
                        _.merge(canvass, data);
                    }
                });
        }

        openDeletePersonDialog(houseoccupant: HouseOccupant, ev: object): void {
            this.dialog
                .delete({
                    fullscreen: true,
                    targetEvent: ev,
                    locals: {
                        bodyText: "They will be permanently deleted",
                        title: `Delete ${houseoccupant.hofname} ${houseoccupant.holname}?`,
                    },
                })
                .then(() => {
                    this.houseOccupantService
                        .delete(houseoccupant.hoid)
                        .then((response: object) => {
                            const json = response["data"];
                            if (json.success) {
                                this.spliceHouseOccupant(
                                    houseoccupant,
                                    this.house.occupants
                                );
                                this.toast.success("Person deleted.");
                            } else {
                                this.toast.error();
                            }
                        });
                });
        }

        spliceHouseOccupant(
            houseoccupant: HouseOccupant,
            houseoccupants: Array<HouseOccupant>
        ): void {
            if (houseoccupants !== null) {
                let houseoccupantIndex = houseoccupants.indexOf(houseoccupant);
                if (houseoccupantIndex > -1) {
                    houseoccupants.splice(houseoccupantIndex, 1);
                }
            }
        }

        initialiseMap(): void {
            if (
                this.house.hlatitude &&
                (this.house.hlatitude + "").trim() != "" &&
                this.house.hlongitude &&
                (this.house.hlongitude + "").trim() != ""
            ) {
                this.setHouseMarker({
                    coords: {
                        longitude: this.house.hlongitude,
                        latitude: this.house.hlatitude,
                    },
                });
            } else {
                this.setHouseMarker();
                if (!this.isLeaderView) {
                    this.locate_house();
                }
            }
        }

        setHouseMarker(location?: any): void {
            if (!location) {
                location = { coords: { latitude: 0, longitude: 0 } };
                this.map.center = _.cloneDeep(location.coords);
                this.map.zoom = 1;
            } else {
                this.map.center = _.cloneDeep(location.coords);
                this.map.zoom = 16;
            }
            this.houseMarker = {
                id: 1,
                coords: location.coords,
            };
        }

        locate_house(): void {
            this.locating = true;
            this.helperService.locate(
                this.house,
                (location: any) => {
                    this.locating = false;
                    if (location) {
                        this.setHouseMarker(location);
                        this.house.hlocationtype = location.locationtype;
                        this.house.hlongitude = location.coords.longitude;
                        this.house.hlatitude = location.coords.latitude;
                        this.house.update();
                    }
                },
                () => (this.locating = false)
            );
        }

        openCreateHouseOccupantDialog(hid: string | number, ev: object): void {
            this.dialog
                .show({
                    component: "vc-house-occupant-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        selectedHoid: null,
                        selectedHid: hid,
                    },
                    ariaLabel: "Person",
                    size: "large",
                })
                .then((data: HouseOccupant) => {
                    this.house.occupants.push(data);
                });
        }

        openViewHouseOccupantDialog(
            houseoccupant: HouseOccupant,
            ev: object
        ): void {
            this.dialog
                .show({
                    component: "vc-view-house-occupant",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        selectedHoid: houseoccupant.hoid,
                    },
                    ariaLabel: "View Person",
                    size: "large",
                })
                .then((data: any) => {
                    if (!data || !data.hoid) return;
                    let houseOccupant = this.occupantWithID(houseoccupant.hoid);
                    if (houseOccupant) {
                        houseOccupant.setData(data);
                    }
                    if (data.house && this.house.notes != data.house.notes) {
                        this.house.setData(data.house);
                    }
                });
        }

        occupantWithID(hoid: number | string): HouseOccupant {
            for (let i = 0; i < this.house.occupants.length; i++) {
                if (this.house.occupants[i].hoid == hoid) {
                    return this.house.occupants[i];
                }
            }
            return null;
        }

        viewBuildingDialog(house: House, ev: object): void {
            this.dialog.show({
                component: "vc-view-building",
                targetEvent: ev,
                scope: this.$scope,
                ariaLabel: "Building",
                locals: {
                    bid: house.bid,
                },
                size: "large",
            });
        }
    },
};

angular
    .module("house")
    .component(HousePaneComponent.selector, HousePaneComponent);
